import request from './request'

//geo
export function apiGeo() {
    return request({
        url: 'api/user/geo',
        method: 'GET'
    })
}

//登录
export function apiUserLogin(data) {
    return request({
        url: 'api/user/login',
        method: 'POST',
        data: data
    })
}

//发送验证码
export function apiSendSms(data) {
    return request({
        url: 'api/sms/send.html',
        method: 'post',
        data: data
    })
}
//发送验证码
export function apiSendSms2(data) {
    return request({
        url: 'api/sms/send',
        method: 'post',
        data: data
    })
}

//注册
export function apiUserRegister(data) {
    return request({
        url: 'api/user/register',
        method: 'get',
        params: data
    })
}


//用户信息
export function getUserInfo(data) {
    return request({
        url: 'api/user/user_info',
        method: 'get',
        params: data
    })
}
//商品列表
export function apiProductList(data) {
    return request({
        url: 'api/product/getList',
        method: 'get',
        params: data
    })
}
//公告列表
export function apiNewsad(data) {
    return request({
        url: 'api/news/ad',
        method: 'get',
        params: data
    })
}

export function apiNewsIndex(data) {
    return request({
        url: 'api/news/index',
        method: 'get',
        params: data
    })
}
//新闻列表
export function apiNewsList(data) {
    return request({
        url: 'api/news/news_list',
        method: 'get',
        params: data
    })
}
//仓库列表
export function apiDepotGet(data) {
    return request({
        url: 'api/depot/get',
        method: 'get',
        params: data
    })
}
export function apiUserLevelDepot(data) {
    return request({
        url: 'api/user/level_depot',
        method: 'get',
        params: data
    })
}
export function apiUserLevelNewDepot(data) {
    return request({
        url: 'api/user/level_depot_with_nocache',
        method: 'get',
        params: data
    })
}

//快递列表
export function apiExpressGet(data) {
    return request({
        url: 'api/depot/express_lst',
        method: 'get',
        params: data
    })
}

export function apiIndexGet(data) {
    return request({
        url: 'api/index/index',
        method: 'get',
        params: data
    })
}


export function apiOrderGetPrice(data) {
    return request({
        url: 'api/order/get_price',
        method: 'get',
        params: data
    })
}

export function apiOrderCreate(data) {
    return request({
        url: 'api/order/create',
        method: 'POST',
        data: data
    })
}


export function apiWalletOnLinePut(data) {
    return request({
        url: 'api/wallet/online_put',
        method: 'get',
        params: data
    })
}

export function apiWalletCheckPay(data) {
    return request({
        url: 'api/wallet/check_pay',
        method: 'get',
        params: data
    })
}

export function apiShopLst(data) {
    return request({
        url: 'api/shop/lst',
        method: 'get',
        params: data
    })
}

export function apiShopOrder(data) {
    return request({
        url: 'api/shop/order',
        method: 'get',
        params: data
    })
}

// 远程同步订单
export function apiShopRemoteOrder(data) {
    return request({
        url: 'api/shop/remote_order',
        method: 'post',
        data: data
    })
}

// 刷新订单
export function apiShopLocationOrder(data) {
    return request({
        url: 'api/shop/location_order',
        method: 'post',
        data: data
    })
}

export function apiOrderList(data) {
    return request({
        url: 'api/order/lst',
        method: 'get',
        params: data
    })
}

export function apiDelivery(data) {
    return request({
        url: 'api/order/delivery',
        method: 'get',
        params: data
    })
}


export function apiOrderPacjAgeLst(data) {
    return request({
        url: 'api/order/packagelst',
        method: 'get',
        params: data
    })
}


// 实名认证
export function apiGetRealQrcode(data) {
    return request({
        url: 'api/index/getRealQrcode',
        method: 'post',
        data: data
    })
}



export function apiShopBuildConfig(data) {
    return request({
        url: 'api/shop/bind_config',
        method: 'post',
        data
    })
}

export function apiShopBuild(data) {
    return request({
        url: 'api/shop/bind_url',
        method: 'post',
        data
    })
}

export function apiShopDyBuild(data) {
    return request({
        url: 'api/shop/dy_bindShop',
        method: 'get',
        params: data
    })
}

export function apiShopWnBuild(data) {
    return request({
        url: 'api/shop/wn_bindShop',
        method: 'get',
        params: data
    })
}

export function apiShopDelete(data) {
    return request({
        url: 'api/shop/del_shop',
        method: 'get',
        params: data
    })
}


export function apiWalletGet(data) {
    return request({
        url: 'api/wallet/get',
        method: 'get',
        params: data
    })
}

export function apiAfterWardsPut(data) {
    return request({
        url: 'api/afterwards/put',
        method: 'post',
        data
    })
}
export function apiAfterWardsGet(data) {
    return request({
        url: 'api/afterwards/get',
        method: 'post',
        data
    })
}

export function apiUserOrderCount(data) {
    return request({
        url: 'api/user/order_count',
        method: 'post',
        data
    })
}

export function apiInviteGet(data) {
    return request({
        url: 'api/invite/get',
        method: 'post',
        data
    })
}
export function apiUserLevelLst(data) {
    return request({
        url: 'api/user/levelLst',
        method: 'post',
        data
    })
}
export function apiNewsDetail(data) {
    return request({
        url: 'api/news/news_detail',
        method: 'post',
        data
    })
}

export function apiSmsCheck(data) {
    return request({
        url: 'api/sms/check',
        method: 'post',
        data: data
    })
}
export function apiUserResetPwd(data) {
    return request({
        url: 'api/user/resetpwd',
        method: 'post',
        data: data
    })
}
export function apiIndexHelp(data) {
    return request({
        url: 'api/index/help',
        method: 'get',
        params: data
    })
}

export function apiUserChangePwd(data) {
    return request({
        url: 'api/user/changepwd',
        method: 'post',
        data
    })
}

export function apiCheckReal(data) {
    return request({
        url: 'api/index/checkReal',
        method: 'post',
        data
    })
}

export function apiIndexFeedback(data) {
    return request({
        url: 'api/index/feedback_put',
        method: 'post',
        data
    })
}

export function apiManyStoreContact(data) {
    return request({
        url: 'api/manystore/contact',
        method: 'post',
        data
    })
}

export function apiDepotGetAll(data) {
    return request({
        url: 'api/depot/get',
        method: 'post',
        data
    })
}

export function apiSenderGet(data) {
    return request({
        url: 'api/sender/get',
        method: 'post',
        data
    })
}
export function apiSenderAdd(data) {
    return request({
        url: 'api/sender/add',
        method: 'post',
        data
    })
}
export function apiSenderEdit(data) {
    return request({
        url: 'api/sender/edit',
        method: 'post',
        data
    })
}

export function apiGetPrintApp(data) {
    return request({
        url: 'api/index/get_print_app',
        method: 'get',
        params: data
    })
}

export function apiGetYtCk() {
    return request({
        url: 'yt_ck',
        method: 'get'
    })
}

export function apiGetNotice() {
    return request({
        url: 'notice',
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js